import './index.css';
import React from "react";
import { render } from "react-dom";
import { App } from "./App";

// META PIXEL
if (typeof window !== "undefined") {
  !function (f: any, b, e, v, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  (window as any).fbq("init", "1393420435325787");
  (window as any).fbq("track", "PageView");
}

// RENDER APP
render(<App data-id="element-391" />, document.getElementById("root"));